import ReportsEditFilters from 'modules/reports/components/Edit/Filters'
import ReportsEditSection from 'modules/reports/components/Edit/Section'
import ReportsTab, {ReportsTabExtensionProps} from 'modules/reports/components/Tab'
import useCore from 'modules/reports/hooks/core'
import React from 'react'
// import useStyles from './ReportsEditFiltersTab.styles'
import {Button} from '@material-ui/core'
import ReportsEditFiltersDock from 'modules/reports/docks/Edit/Filters'
import useDock from 'modules/reports/hooks/dock'
import AddIcon from '@material-ui/icons/Add'

type Props = ReportsTabExtensionProps & {}

function ReportsEditFiltersTab(props: Props) {
  // const classes = useStyles()
  const {p, pt} = useCore('reports', 'tabs', 'EditFilters')
  const dock = useDock()

  function handleAdd() {
    dock.open(ReportsEditFiltersDock, {})
  }

  return (
    <ReportsTab {...props} label={pt('label')} data-testid={p()}>
      <ReportsEditSection
        title={pt('title')}
        data-testid={p('filters-section')}
        action={
          <Button onClick={handleAdd} size="small" startIcon={<AddIcon fontSize="small" />}>
            {pt('add-filter')}
          </Button>
        }
      >
        <ReportsEditFilters />
      </ReportsEditSection>
    </ReportsTab>
  )
}

export default ReportsEditFiltersTab
